import { GET_OSSSELECT } from '@/api/oss'
import { isResponseCodeSuccess } from '../tools/util'
import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

// 进项票详情
interface State {
  getOssSelect: () => Promise<void>
  accessKeyId: string
  accessKeySecret: string
}

export const useOssStore = create<State>()(
  devtools((set) => ({
    accessKeyId: '',
    accessKeySecret: '',
    async getOssSelect() {
      const res = await GET_OSSSELECT()
      if (isResponseCodeSuccess(res.code)) {
        set({
          accessKeyId: res.data.accessKeyId,
          accessKeySecret: res.data.accessKeySecret,
        })
      }
    },
  })),
)
import { GET_OSSSELECT } from '@/api/oss'
import { isResponseCodeSuccess } from '../tools/util'
import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

// 进项票详情
interface State {
  getOssSelect: () => Promise<void>
  accessKeyId: string
  accessKeySecret: string
}

export const useOssStore = create<State>()(
  devtools((set) => ({
    accessKeyId: '',
    accessKeySecret: '',
    async getOssSelect() {
      const res = await GET_OSSSELECT()
      if (isResponseCodeSuccess(res.code)) {
        set({
          accessKeyId: res.data.accessKeyId,
          accessKeySecret: res.data.accessKeySecret,
        })
      }
    },
  })),
)
